import App from "../app/single_page_scripts/app";
import Profiles from "../app/single_page_scripts/profiles";

let app = new App();
new Profiles(app);
